import type {UnidentifiedChannel, UnidentifiedMessage} from "./types"

type ChannelPresenter = {
	title: (message: UnidentifiedMessage) => string
	sourceLabel: (message: UnidentifiedMessage) => string
	sourceTag: (message: UnidentifiedMessage) => string
	senderLabel: (message: UnidentifiedMessage) => string
}

const email: ChannelPresenter = {
	title: (message) => (message.Subject?.trim() ? message.Subject : "(no subject)"),
	sourceLabel: (message) => message.Mailbox,
	// The support mailboxes differ only by their region suffix, so the chip
	// carries that and the full address rides along as the title.
	sourceTag: (message) => message.Mailbox.split("@")[0].replace("customersupport-", "").toUpperCase(),
	senderLabel: (message) =>
		message.From.Label.trim() ? `${message.From.Label} · ${message.From.Address}` : message.From.Address,
}

const sms: ChannelPresenter = {
	title: (message) => `SMS from ${message.From.Address}`,
	sourceLabel: (message) => `Our number ${message.Mailbox}`,
	sourceTag: (message) => message.Mailbox,
	senderLabel: (message) => message.From.Address,
}

function channelPresenter(channel: UnidentifiedChannel): ChannelPresenter {
	return channel === "sms" ? sms : email
}

function itemPath(channel: string, conversationID: string, providerMessageID: string): string {
	return `/inbox/${encodeURIComponent(channel)}/${encodeURIComponent(conversationID)}/${encodeURIComponent(providerMessageID)}`
}

export {channelPresenter, itemPath}
export type {ChannelPresenter}
